import type { FaireProductEntity } from "../../entity_types/product";

export const p_thwqjey5su: FaireProductEntity = {
  token: "p_thwqjey5su",
  type: "product",
  name: "Crystal Gemstone Frog - Carved Toads",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/be2453e4ab0e832960d9b3faa5f77a69964c2d4e5417612741e0a4e60b46bb63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/189c5af41ef92c9f6ece1878e6bf04a4d6a6915a5c8769fa22a2aa8f6101b45d.jpeg",
    "https://cdn.faire.com/fastly/f023f002acc368e231c1629400daaa048a309019eabb5ac3f3ac3ce645d8249a.jpeg",
    "https://cdn.faire.com/fastly/1bffb8f9abe9000b5cfa09fe51a6930cb8d61ad90499f734e06d3f4c1c74bd5e.jpeg",
    "https://cdn.faire.com/fastly/941d31160018f9c4f7c1f0daa08b45ad4b53215544170c24816942f441790b88.jpeg",
    "https://cdn.faire.com/fastly/221ad1bac408190c3d4e9d702b1a293639d48bffa2f9a2c2b0906754d2bdaf38.jpeg",
  ],
  priceDollars: 6.24,
  description:
    'Crystal\nListing is for ONE (1) Gemstone Frog (LWS-S2)\n\nFrogs carved out of gemstones! These are carved out one by one making each one special and unique. You choose your desired stone. \n\nSTOCK PHOTO. Measurements, characteristics, and colors may vary. Each one is carved out by hand so some may be bigger, thicker, and wider while some can be thinner and shorter.\n\nMeasures Approx.: 1.75\' Long x 1" wide x.75" tall - 1.75" long x 1.25" wide x 1" tall\n\nYou Choose your stone! Available in:\n\nMoss Agate - Emotional Balance\nGreen Aventurine - strength and Courage\nOpalite - Peace and Tranquility\nRose Quartz - Love Stone\nOrange Calcite - Joy and Creativity\nFluorite - Peaceful Energy\nWhite Howlite - Attunement Stone\nBlack Obsidian - Protection Stone\n\n***Information provided is folklore and not intended as medical advice or a promise of any outcome.\n\nWe have your best interest at heart.\nWe hope that each user has a positive experience with our products.***',
  tags: [],
  msrpDollars: 12.47,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:46.944Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
